<div class="filter-badget-container">
    <div class="filter-header">Filters:</div>
    <div class="filter-item-wrapper">
        <ng-container *ngFor="let filterItem of filterArr">
            <div class="filter-badget" *ngIf="filterItem.label">
                <mat-icon class="badget-action" (click)="onRemoveFilter(filterItem.key)" svgIcon="xclose"></mat-icon>
                <span class="filter-item-label"> {{ filterItem.label }} </span>
            </div>
        </ng-container>
    </div>
</div>
